import React from "react";

import DashboardHomeCard from "components/Cards/DashboardHomeCard";
import LearningPathCard from "components/Cards/LearningPathCard";
import Button from "components/Form/Button";
import HorizontalScrollCarousel from "components/HorizontalScrollCarousel";
import useI18n from "hooks/useI18n";
import { SectionAction, SectionCards, SectionHeader, SectionRoot, SectionTitle } from "./styled";

export default function DashboardHomeSection({ section, onAction }) {
    const { t } = useI18n();
    const viewAllAction = section?.viewAllAction || { type: "navigate", value: "/sub-category/courses" };
    const items = Array.isArray(section?.items) && section.items.length
        ? section.items
        : section?.courses || [];
    const isTrailSection = ['learning-paths', 'knowledge-trails'].includes(section?.key)
        || items.some(item => ['learning-paths', 'knowledge-trails'].includes(item?.type));

    return (
        <SectionRoot>
            <SectionHeader>
                <SectionTitle>{section?.title}</SectionTitle>

                <SectionAction>
                    <Button outline color="white" width="fit-content" nospace small onClick={() => onAction(viewAllAction)}>
                        {t("see_all")}
                    </Button>
                </SectionAction>
            </SectionHeader>

            <SectionCards>
                <HorizontalScrollCarousel gap={18}>
                    {items.map((item) => (
                        isTrailSection ? (
                            <LearningPathCard
                                key={`${section?.key}-${item?.id}-${item?.type}`}
                                item={item}
                                onAction={onAction}
                            />
                        ) : (
                            <DashboardHomeCard
                                key={`${section?.key}-${item?.id}-${item?.type}`}
                                item={item}
                                onAction={onAction}
                            />
                        )
                    ))}
                </HorizontalScrollCarousel>
            </SectionCards>
        </SectionRoot>
    );
}
